import axios from 'axios';
export default (appId, obj) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .patch(process.env.VUE_APP_API_ADMIN_LOCATION + `appointments/${appId}`, {
        due: obj.due,
      })
      .then((data) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
